var _g, _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_b_175_1461)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FEE3F1"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.2859,
    cy: 23.7143,
    r: 18.3054,
    stroke: "#FB89C5",
    strokeWidth: 1.675
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9798 12.5367L27.7055 18.0395C27.7675 18.1792 27.865 18.3002 27.9883 18.3904C28.1116 18.4807 28.2565 18.537 28.4083 18.5538L34.4254 19.4452C34.5998 19.4676 34.764 19.5391 34.8991 19.6514C35.0342 19.7637 35.1346 19.912 35.1885 20.0792C35.2425 20.2464 35.2476 20.4255 35.2035 20.5955C35.1597 20.7656 35.0681 20.9196 34.9397 21.0395L30.6026 25.3424C30.492 25.4458 30.4089 25.5753 30.361 25.719C30.313 25.8627 30.3019 26.0161 30.3283 26.1652L31.374 32.2166C31.4043 32.3906 31.3851 32.5694 31.3188 32.733C31.2525 32.8965 31.1415 33.0381 30.9986 33.1418C30.8558 33.2454 30.6866 33.3067 30.5105 33.3191C30.3345 33.3312 30.1584 33.2939 30.0026 33.2109L24.5855 30.348C24.4468 30.28 24.2943 30.2447 24.1398 30.2447C23.9852 30.2447 23.8328 30.28 23.6941 30.348L18.2769 33.2109C18.1211 33.2939 17.9451 33.3312 17.769 33.3191C17.5929 33.3067 17.4238 33.2454 17.2809 33.1418C17.138 33.0381 17.0271 32.8965 16.9607 32.733C16.8944 32.5694 16.8752 32.3906 16.9055 32.2166L17.9512 26.0967C17.9777 25.9475 17.9665 25.7941 17.9186 25.6504C17.8707 25.5067 17.7876 25.3772 17.6769 25.2738L13.2883 21.0395C13.1585 20.9163 13.0672 20.758 13.0255 20.5839C12.9838 20.4098 12.9934 20.2273 13.0533 20.0586C13.1132 19.8899 13.2207 19.7422 13.3628 19.6333C13.5049 19.5244 13.6756 19.4591 13.8541 19.4452L19.8712 18.5538C20.0231 18.537 20.1679 18.4807 20.2912 18.3904C20.4146 18.3002 20.5121 18.1792 20.5741 18.0395L23.2998 12.5367C23.374 12.3764 23.4925 12.2407 23.6414 12.1456C23.7902 12.0505 23.9631 12 24.1398 12C24.3164 12 24.4893 12.0505 24.6382 12.1456C24.787 12.2407 24.9055 12.3764 24.9798 12.5367Z",
    stroke: "#FB89C5",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_175_1461",
    x: -4,
    y: -4,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_175_1461"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_175_1461",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStar);
export default __webpack_public_path__ + "static/media/IconStar.a2ed2ca5ee7f53611f3d30988c8c47c9.svg";
export { ForwardRef as ReactComponent };